import React from "react";
import IconTextCard, {
  IconTextCardProps,
} from "@/components/ui/icon-text-card";
import { cn } from "@/lib/utils";

export interface TypesOfMedicalStaffingSolutionsProps {
  id?: string;
  className?: string;
  title?: string;
  items?: IconTextCardProps[];
}

const TypesOfMedicalStaffingSolutions: React.FC<
  TypesOfMedicalStaffingSolutionsProps
> = ({
  id = "types-of-medical-staffing-solutions",
  className,
  title = "Types of Medical Staffing Solutions",
  items = [
    {
      title: "On-Demand Staffing",
      description:
        "Immediate availability and flexibility for unexpected call-offs, patient volume surges, or short-term needs.",
    },
    {
      title: "Supplemental Staffing",
      description:
        "Temporary placements to bridge staffing gaps and to ensure continuity of care for all patients and residents.",
    },
    {
      title: "Direct Hire Placements",
      description:
        "Find the perfect long-term fit for your team with our comprehensive recruitment services.",
    },
  ],
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn("bg-primary-100", className)}
    >
      <div className="mx-auto flex w-full max-w-lg flex-col gap-6 p-4 md:gap-8 md:px-6 md:py-8 lg:gap-10 lg:px-3 lg:py-10">
        <h2 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
          {title}
        </h2>
        <div className="flex flex-col gap-4 px-0 md:flex-row md:gap-8 md:px-4 lg:gap-20 lg:px-[72px]">
          {items?.map((benefit, index) => (
            <IconTextCard
              className="basis-1/3 lg:p-0"
              textClassName=""
              titleClassName=""
              descriptionClassName=""
              key={`${benefit.title}-${index}`}
              {...benefit}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TypesOfMedicalStaffingSolutions;
